/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import Responsive from 'react-responsive';
import xss from 'xss';
import { first } from 'lodash';
import { getItemFromStore } from '../../../utils/sessionStorage';
import { store } from '../../../configureStore';
import { preFetchConsts, cradleThrottleValues, CART_CONTACT_INFO_INTG } from './constants';
import { getQueryParamByName } from './queryParams';

export const getIntendType = (pageName) => {
  let intendTypeval = '';
  const FlowType = getSession('FlowType');
  if (getSession('isCBandQual') === 'Y') {
    if (getLTEUpgrade()) {
      intendTypeval = '4GLTEUpgrade';
    } else if (isMoversFlow()) {
      intendTypeval = 'movers';
    } else {
      if (getAPPID() === 'AAL') intendTypeval = 'AAL_5G';
      else {
        intendTypeval = 'NSE_5G';
      }
      // if (pageName && pageName === 'homeplan' && (intendTypeval === 'AAL_5G' || intendTypeval === 'NSE_5G')) intendTypeval = '';
      if (pageName && pageName === 'payment') {
        if (intendTypeval === 'AAL_5G' || intendTypeval === 'AAL_LTE') {
          intendTypeval = 'AAL';
        } else if (intendTypeval === 'NSE_5G' || intendTypeval === 'NSE_LTE') {
          intendTypeval = 'NSE';
        }
      }
    }
  } else if (getLTEUpgrade()) {
    intendTypeval = '4GLTEUpgrade';
  } else if (isMoversFlow()) {
    intendTypeval = 'movers';
  } else if (isWHW()) intendTypeval = 'ACC';
  else if (getAPPID() === 'AAL' && FlowType && FlowType === '5G') intendTypeval = 'AAL_5G';
  else if (getAPPID() === 'AAL' && FlowType && FlowType === 'LTE') intendTypeval = 'AAL_LTE';
  else if (FlowType && FlowType === '5G') intendTypeval = 'NSE_5G';
  else if (FlowType && FlowType === 'LTE') intendTypeval = 'NSE_LTE';
  // if (pageName && pageName === 'homeplan' && (intendTypeval === 'AAL_5G' || intendTypeval === 'NSE_5G')) intendTypeval = '';
  else if (pageName && pageName === 'payment') {
    if (intendTypeval === 'AAL_5G' || intendTypeval === 'AAL_LTE') {
      intendTypeval = 'AAL';
    } else if (intendTypeval === 'NSE_5G' || intendTypeval === 'NSE_LTE') {
      intendTypeval = 'NSE';
    }
  }
  return intendTypeval;
};

export const getFlowTypeWithIntend = () => {
  let val = '';
  // const d = Date.now();
  // const hours = d.getHours();
  // const minute = d.getMinutes();
  // const seconds = d.getSeconds();
  // const timeformat = `${hours}:${minute}:${seconds}`;
  const timeformat = Date.now();
  if (getSession('CustTab') === null) {
    setSession('CustTab', timeformat);
  }
  const FlowType = getSession('FlowType');
  const isTestFlow = getSession('isTestFlow');
  const isExistingCase = getSession('ExistingCase');
  const isemailFlow = getSession('emailFlow');
  const isResumeOrder = getSession('isResumeOrder');
  const isResumeAbandoned = getItemFromStore('isResumeAbandoned');
  const { search } = window.location;
  const params = new URLSearchParams(search);
  let OTGFlow = false;
  if (params.has('source')) {
    OTGFlow = true;
  }
  if (FlowType && FlowType === 'LTE') {
    if (getAPPID() === 'AAL') {
      val = 'AAL_LTE|LTE';
    } else {
      val = 'NSE_LTE|LTE';
    }
  } else if (FlowType && FlowType === '5G') {
    if (getSession('isCBandQual') === 'Y') {
      if (getAPPID() === 'AAL') {
        val = 'AAL_5G|CBD';
      } else {
        val = 'NSE_5G|CBD';
      }
    } else if (getSession('isCBandQual') !== 'Y') {
      if (getAPPID() === 'AAL') {
        val = 'AAL_5G|mmWv';
      } else {
        val = 'NSE_5G|mmWv';
      }
    }
  }
  if (OTGFlow) {
    val = `OTG|${val}`;
  }
  if (isExistingCase) {
    val = `SCEXISTS|${val}`;
  }
  if (isemailFlow) {
    val = `RETRIEVEEMAIL_5G|${val}`;
  }
  if (isResumeOrder === 'Y') {
    val = `RETRIEVEYES|${val}`;
  }
  if (isResumeOrder === 'N') {
    val = `RETRIEVENO|${val}`;
  }
  if (isWHW()) {
    val = 'WHW_Redemption';
  }
  if (isTestFlow && isTestFlow === 'Y') {
    val = `test|${val}`;
  }
  const { cartDetails } = store.getState();
  if (isPreorder() || (cartDetails && cartDetails.isPreorder)) {
    val += '|PREORDER';
  }
  if (
    getSession('UCFlowName') !== null &&
    getSession('UCFlowName') !== 'null' &&
    getSession('UCFlowName') !== undefined &&
    getSession('UCFlowName') !== ''
  ) {
    val += `|${getSession('UCFlowName')}`;
  }
  if (isResumeAbandoned && getAPPID() === 'NSE') {
    val += '|AbCart';
  }

  if (getSession('isPlansRetry') === 'Y') {
    val += '|PLAN_RS';
  }
  if (getSession('isPaymentFailRetry') === 'Y') {
    val += '|PG_RS';
  }
  if (getSession('isTransExpiryRetry') === 'Y') {
    val += '|SG_RS';
  }
  if (getSession('noAppointment') === 'Y') {
    val += '|APPTMT_RS';
  }
  if (getSession('emptyCartLQ') === 'Y') {
    val += '|ECL'; // ECL means Empty CartExist and LQResponse
  }
  if (getSession('sesExp') === 'Y') {
    val += '|ESF'; // ESF means Expired Session Flow
  }
  if (isMoversFlow()) {
    val = `MOV|${val}`;
  }
  if (getSession('CustTab') !== null && getSession('CustTab') !== 'null' && getSession('CustTab') !== undefined && getSession('CustTab') !== '') {
    val += `|${getSession('CustTab')}`;
  }
  if (getSeqFlowType() === 'MOC_FWA') {
    val += '|SEQ_MH'; // Sequential Flow Mobilitiy Order confirmation page to FWA
  }
  if (getSeqFlowType() === 'MEC_FWA_NSE') {
    val += '|SEQ_MH_MEC_NSE'; // Sequential Flow Mobilitiy confirmation Email to FWA with Guest Account
  }
  if (getSeqFlowType() === 'MEC_FWA_AAL') {
    val += '|SEQ_MH_MEC_AAL'; // Sequential Flow Mobilitiy confirmation Email to FWA with AAL Account
  }
  if (getSession(CART_CONTACT_INFO_INTG) === 'Y') {
    val += '|INT_CART_CONTACT'; // cart and contact integration
  }

  return val;
};

export const getFlowType = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  let isWHW = false;
  if (getSession('WHW') === 'true' || getSession('WHW') === true || params.has('whwf_redeem')) {
    isWHW = true;
  }
  let flowType = '';
  flowType = isWHW && viewport() === 'mfapp' ? getCookie('FlowType') : getSession('FlowType');
  return flowType;
};

export const getCookie = (name) => {
  const cookies = new Cookies();
  const cookieValue = cookies.get(name) || '';
  if (cookieValue !== '') {
    return decodeURIComponent(cookieValue);
  }
  return cookieValue;
};

export const setCookie = (cookieName, value) => {
  // console.log('encode', encodeURIComponent(value));
  // console.log(`?x=${encodeURIComponent('test')}`);
  // document.cookie = `${`${cookieName}` + '='}${encodeURIComponent(`${value}`)};path=/`;
  document.cookie = `${cookieName}=${encodeURIComponent(value)};path=/`;
};

export const isCookieExists = (name) => {
  if (getCookie(name)?.trim()) {
    return name;
  }
  return false;
};

export const getSession = (name) => {
  let value;
  // const LQSession =
  //   name.includes('LQResponse') ||
  //   name.includes('isCBandQual') ||
  //   name.includes('FlowType') ||
  //   name.includes('isPreorder') ||
  //   name.includes('cbandPro') ||
  //   name.includes('isTestFlow') ||
  //   name.includes('UCFlowName') ||
  //   name.includes('bulkQualIndicator') ||
  //   name.includes('cartExist') ||
  //   name.includes('pastDueBalAmount') ||
  //   name.includes('isMovers') ||
  //   name.includes('ONResponse') ||
  //   name.includes('subFlowName') ||
  //   name.includes('ExistingCase');
  if (window.vzFlags?.localStorage === true || sessionStorage.getItem('localStorage') === 'true' || sessionStorage.getItem('localStorage') === true) {
    value = window.localStorage.getItem(name);
  } else {
    value = window.sessionStorage.getItem(name);
  }
  // console.log('name', name, value);
  return value;
};

export const isMoversFlow = () => {
  let moversFlow = false;
  const AAL = getAPPID() === 'AAL';
  if (AAL) {
    const moversSession = getSession('isMovers') || window.location.href.indexOf('movers') > -1;
    const moversCookie = getCookie('isMovers') && getCookie('isMovers') !== false ? getCookie('isMovers') : false;
    moversFlow = !!(moversCookie && moversSession);
  }
  return moversFlow;
};
export const isRetailFlow = () => {
  let retailFlow = false;

  if (window.location.href.indexOf('retail') > -1) retailFlow = true;

  return retailFlow;
};

export const isCPCCheckAvailabilityFlow = () => {
  let addressQual = false;
  if (window.location.href.indexOf('cpcCheckAvailability') > -1) addressQual = true;
  return addressQual;
};

export const isComboFlow = () => window.location.href.indexOf('combo') > -1;

export const isExternalFlow = () => window.location.href.indexOf('external') > -1;
export const isBroadBandFlow = () =>
  getCookie('site') === 'InternalFlow' || getCookie('site') === 'NRFlow' || getSession('fcc') === true || getSession('fcc') === 'true';

export const isFooterRequired = () =>
  getCookie('site') === 'InternalFlow' || getCookie('site') === 'NRFlow' || window.location.href.indexOf('broadBandFacts') > -1;

export const isOCOFlow = () => {
  const ocoFlow = getCookie('OCOFlow') && getCookie('OCOFlow') ? getCookie('OCOFlow') : 'false';
  return ocoFlow;
};

export const setSession = (sessionName, value) => {
  // const LQKey = sessionName.includes('ExistingCase');
  if (window.vzFlags?.localStorage) {
    window.localStorage.setItem(sessionName, value);
  } else {
    window.sessionStorage.setItem(sessionName, value);
  }
};

export const getServiceUrlandE2eRequestId = (method, response = null) => {
  let e2eid = response?.headers?.e2erequestid || '';
  if (!e2eid && response?.headers) {
    const e2eHeaderKey = Object.keys(response.headers).find((item) => item?.toLowerCase() === 'e2erequestid');
    if (e2eHeaderKey) {
      e2eid = response.headers[e2eHeaderKey];
    }
  }
  let serviceUrl;
  if (response) {
    // If serviceUrl is provided then always log the service that matches that
    serviceUrl = response?.config?.url;
  }
  return { method, e2eid, serviceUrl };
};

export const getPageName = () => {
  const name = getUrlName(window.location.href);
  let pageName = '';
  switch (name) {
    case 'plansOverview':
      pageName = 'plansoverview';
      break;
    case 'plans':
      pageName = 'homePlanDetails';
      break;
    case 'addons':
      pageName = 'getStreamingDevices';
      break;
    case 'setup':
      pageName = 'deviceSetup';
      break;
    case 'cart':
      pageName = 'getCartDetails';
      break;
    case 'contactinfo':
      pageName = 'getContactInfo';
      break;
    case 'payment':
      pageName = 'getCustomerPaymentInfo';
      break;
    case 'appointment':
      pageName = 'getAvailableInstallationDates';
      break;
    case 'shipping':
      pageName = 'displayShippingOptions';
      break;
    case 'creditcheck':
      const eidStatus = getSession('showEid');
      // const eidStatus = getItemFromStore('showEid');
      if (eidStatus === 'true') {
        pageName = 'EID';
      } else {
        pageName = 'creditCheck';
      }
      break;
    case 'creditstatus':
      pageName = 'creditstatus';
      break;
    case 'confirmation':
      pageName = 'orderConfirmation';
      break;
    case 'orderreview':
      pageName = 'reviewOrder';
      break;
    case 'revieworder':
      pageName = 'revieworder';
      break;
    case 'orderReview':
      pageName = 'orderReview';
      break;
    case 'expresscart':
      pageName = 'expresscart?ONFail=Y';
      break;
    case 'sendlink':
      pageName = 'sendlink';
      break;
    case 'landing':
      pageName = 'landing';
      break;
    case 'registration':
      pageName = 'registration';
      break;
    case 'techexpresscart':
      pageName = 'techexpresscart';
      break;
    case 'addresslookup':
      pageName = 'addresslookup';
      break;
    case 'broadBandFacts':
      pageName = 'broadBandFacts';
      break;
    case 'addressSearch':
      pageName = 'addressSearch';
      break;
    case 'ext-addressSearch':
      pageName = 'ext-addressSearch';
      break;
    default:
      pageName = '';
      break;
  }
  return pageName;
};

// export const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

export const isMobile = () => {
  // debugger;
  if (
    navigator.userAgent.match(/Android/i) ||
    navigator.userAgent.match(/webOS/i) ||
    navigator.userAgent.match(/iPhone/i) ||
    navigator.userAgent.match(/BlackBerry/i) ||
    navigator.userAgent.match(/Windows Phone/i) ||
    navigator.userAgent.match(/MY_VZW_APP/i) ||
    navigator.userAgent.includes('MY_VZW_APP')
  ) {
    return true;
  }
  return false;
};

export const isTablet = () => {
  if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
    return true;
  }
  let userAgentString = window.navigator && window.navigator.userAgent;
  if (userAgentString) {
    userAgentString = userAgentString.toLowerCase();
    if (
      (userAgentString.includes('windows') && userAgentString.includes('touch')) ||
      userAgentString.includes('tablet') ||
      userAgentString.includes('ipad')
    ) {
      return true;
    }
  }

  return false;
};

// To check the resolution is similar to desktop which is above 1024
export const isDesktopResolution = () => window.innerWidth >= 1025;
export const isMobileResolution = () => window.innerWidth < 768;

export const isIPad = () => {
  let userAgentString = window.navigator && window.navigator.userAgent;
  const vendor = window.navigator && window.navigator.vendor;

  if (window.innerWidth && (window.innerWidth <= 1024 && window.innerWidth >= 768)) {
    if (userAgentString && vendor && vendor !== 'Google Inc.') {
      userAgentString = userAgentString.toLowerCase();
      if (userAgentString.includes('ipad')) {
        return true;
      }

      return navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
    }
  }
  return false;
};

export const viewport = () => {
  let viewPort = '';
  if (isMVA()) {
    viewPort = 'mfapp';
  } else if (isMobile()) {
    viewPort = 'mobile';
  } else if (isTablet()) {
    viewPort = 'tablet';
  } else {
    viewPort = 'desktop';
  }
  return viewPort;
};

export const priceFormat = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat
        .replace('$', '')
        .replace(/,/g, '')
        .trim();
      return `$${parseFloat(price).toFixed(2)}`;
    }
    return '$0.00';
  }
  return '$0.00';
};

export const nonFloatingPrice = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').trim();
      return `$${parseFloat(price).toFixed(0)}`;
    }
    return '$0';
  }
  return '$0';
};

export const getParameterByName = (name) => {
  const url = window.location.href;
  const urlname = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${urlname}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  // const result = results[2].replace(/\+/g, ' '); // .replace('/', '');
  let result = '';
  if (urlname === 'navState') {
    result = results[2].replace('/', '');
  } else {
    result = results[2].replace(/\+/g, ' ');
  }
  return decodeURIComponent(result);
};

export const renderHTML = (data) => <span dangerouslySetInnerHTML={{ __html: data }} />;

export const renderHTMLBasic = (data) => <span dangerouslySetInnerHTML={{ __html: data }} />;

export const validateHTML = (str) => {
  if (str) {
    return xss(str, {
      onIgnoreTagAttr(tag, name, value) {
        if (name === 'id' || name === 'style') {
          return `${name}="${xss.escapeAttrValue(value)}"`;
        }
      },
    });
  }
  return '';
};

// export const showFooter = () => {
//   const globalFooter = document.getElementById('vzw-gf');
//   if (globalFooter) {
//     globalFooter.classList.remove('is-hidden');
//   }
//   const newGlobalFooter = document.getElementById('vz-gf20');
//   if (newGlobalFooter) {
//     newGlobalFooter.classList.remove('is-hidden');
//   }
// };

export const validateUrl = (str) => {
  if (str) {
    return str.replace(/</g, '<').replace(/>/g, '>');
  }
  return '';
};

export const isMVA = () => window.navigator.userAgent.indexOf('MY_VZW_APP') > -1;
// export const isMVA = () => true;

export const iOSAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-IOS') > -1;

export const androidAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-ANDROID') > -1;

// export const vh = (percent = 1) => {
//   // Editor Mode
//   if (window.wcmmode === 'edit') {
//     return `${(percent / 100) * 1080}px`;
//   }
//   // Published Mode
//   return `${percent}vh`
// };

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getUrlName = (url) => {
  let items = url.split('.html');
  if (items.length > 0) {
    items = items[0].split('/');
    return items[items.length - 1];
  }
  return url;
};

export const songbirdScript = () =>
  window.vzFlags && window.vzFlags.isProd
    ? 'https://includes.ccdc02.com/cardinalcruise/v1/songbird.js'
    : 'https://includestest.ccdc02.com/cardinalcruise/v1/songbird.js';

export const googleMapScript = () =>
  'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&client=gme-verizonwireless2&channel=vzw-desktop';

export const getApplePayMerchantIdentifier = () => (window.vzFlags && window.vzFlags.isProd ? 'merchant.com.vzw.MVM' : 'merchant.com.vzw.test');

export const getTimeDifferenceFromToday = (fromDate) => {
  const timeZone = 'EST';
  const counter = typeof window.duration !== 'undefined' ? window.duration : 0;
  const givenDate = new Date(`${fromDate.split('-').join('/')} ${timeZone}`).getTime();
  const formattedGivenDate = new Date(givenDate);
  const today = new Date();
  const msDiff = typeof window.duration !== 'undefined' ? counter : formattedGivenDate - today;
  return msDiff;
};

// to Identify Desktop, Mobile
export const Mobile = (props) => <Responsive {...props} maxWidth={512} />;

export const maskCard = (str) => str.substring(0, str.length - 4).replace(/./g, '0') + str.substring(str.length - 4, str.length);

// getappid
export const getAPPID = () => {
  /** In Sequential Flow (Mobility Email to FWA) customer will be logged in with guest account.
   * In this scenario we will have loggedIn as true and role as guest in cookie.
   * We need to consider as NSE flow so added this MEC_FWA_NSE condition.
   */

  if (getSeqFlowType() !== 'MEC_FWA_NSE' && getCookie('loggedIn') === 'true') {
    return 'AAL';
  }
  return 'NSE';
};

export const getLTEUpgrade = () => {
  if (getSession('EUPUpgrade') === 'true') {
    return true;
  }
  return false;
};
export const isEUPFlow = () => {
  // const ocoFlow = getCookie('eUPFlow') && getCookie('eUPFlow') ? getCookie('eUPFlow') : 'false';
  const ocoFlow = window.location.href.indexOf('/eup/') > -1 || getCookie('eUPFlow') ? 'true' : 'false';
  return ocoFlow;
};
export const TechFlow = () => {
  const techFlow = window.location.href.indexOf('/tech/') > -1 || getCookie('techFlow') ? 'true' : 'false';
  return techFlow;
};
export const eagleCPCFlow = () => {
  const techFlow = window.location.href.indexOf('/cpc/') > -1 || getCookie('cpcFlow') ? 'true' : 'false';
  return techFlow;
};
export const whwTech = () => {
  const techFlow = window.location.href.indexOf('/whwTech/') > -1 || getCookie('whwTech') ? 'true' : 'false';
  return techFlow;
};
export const crossSiteCheckUrl = (str) => {
  if (str) {
    return xss(str);
  }
  return '';
};

export const pod2 = (number) => (number < 10 ? '0' : '') + number;

export const isAndroid = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const android = userAgent.indexOf('android') > -1;
  return android;
};

export const removeOneDuplicate = (arr, itemToRemove) => {
  const result = arr;
  const index = result.indexOf(itemToRemove);
  if (index > -1) {
    result.splice(index, 1);
  }
  return result;
};

function getDate(mm, dd, yyyy) {
  let month;
  let day;
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  if (mm && dd && yyyy) {
    day = Number(dd);
    month = Number(mm) - 1;
  } else {
    const today = new Date();
    day = today.getDate();
    month = today.getMonth();
  }
  if (day < 10) day = `0${day}`;
  return `${monthNames[month]} ${day}`;
}

export const convertDateRange = (dateRange) => {
  if (!dateRange) return null;
  const dates = dateRange.split('-');
  const len = dates.length - 1;
  let accumR;
  return dates.reduce((accum, date, index) => {
    const mm = date.split('/')[0];
    const dd = date.split('/')[1];
    const yyyy = date.split('/')[2];
    accumR = accum;
    if (index !== len) accumR += `${getDate(mm, dd, yyyy)} - `;
    else accumR += getDate(mm, dd, yyyy);
    return accumR;
  }, '');
};

export const getProcessStep = () => {
  const FlowType = getSession('FlowType');
  const isCBandQual = getSession('isCBandQual');
  const isCBandFlow = getSession('isCBandFlow');
  const LQResponseData = getSession('LQResponse');
  const bundleDetails = LQResponseData ? JSON.parse(LQResponseData)?.output?.bundleDetails : '';
  const bundleDetailsLength = bundleDetails && bundleDetails.length > 0;
  const iscbandPro = getSession('cbandPro');

  // Setup page wont be available
  if ((isCBandQual === 'Y' && isCBandFlow === 'Y' && FlowType === '5G' && !bundleDetailsLength && !iscbandPro) || FlowType === 'LTE') {
    return 'Accessories';
  }
  // Setup page will be available
  return 'InstallType';
};

export const isPreorder = () => {
  if (getSession('isPreorder') === 'true' || getSession('isPreorder') === true) {
    return true;
  }
  return false;
};

export const getBundleCategory = () => [];

export const dayAndMonth = (date) => {
  if (date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const requiredDate = new Date(date);
    const day = days[requiredDate.getDay()];
    const dayDigit = requiredDate.getDate();
    const month = months[requiredDate.getMonth()];
    const formattedMonth = month && month.substring(0, 3);
    const requiredFormat = `${day}, ${formattedMonth} ${dayDigit}`;
    return requiredFormat;
  }
  return '';
};

export const isLoggedIn = () => getAPPID() === 'AAL';

export const getBrowserName = () => {
  const { userAgent } = navigator;
  let browserName;
  // ORDER MUST BE MAINTAINED
  if (userAgent && typeof userAgent === 'string') {
    if (userAgent.match(/(OPR|Opera)\/.*/i)) {
      // Has to be before Safari & Chrome
      browserName = 'Opera';
    } else if (userAgent.match(/Seamonkey\/.*/i)) {
      // Has to be before Firefox
      browserName = 'Seamonkey';
    } else if (userAgent.match(/Vivaldi\/.*/i)) {
      // Has to be before Chrome and Safari
      browserName = 'Vivaldi';
    } else if (userAgent.match(/YaBrowser\/.*/i)) {
      // Has to be before Chrome and Safari
      browserName = 'Yandex';
    } else if (userAgent.match(/(Edge|Edg|EdgA|EdgiOS)\/.*/i)) {
      // How to distinguish Edge Chromium vs other? Just by Blink engine?
      browserName = 'Edge';
    } else if (userAgent.match(/Firefox\/.*/i)) {
      // !userAgent.match(/Seamonkey\/.*/i)
      browserName = 'Firefox';
    } else if (userAgent.match(/Chrome\/.*/i) && !userAgent.match(/Chromium\/.*/i)) {
      // Has to be before Safari
      browserName = 'Chrome';
    } else if (userAgent.match(/Safari\/.*/i) && !userAgent.match(/Chrome\/.*/i) && !userAgent.match(/Chromium\/.*/i)) {
      browserName = 'Safari';
    } else if (userAgent.match(/; MSIE.*;/i)) {
      browserName = 'Internet Explorer <= 10';
    } else if (userAgent.match(/Trident\/.*; rv:.*/i)) {
      browserName = 'Internet Explorer 11';
    } else if (userAgent.match(/Chromium\/.*/i)) {
      browserName = 'Chromium';
    } else {
      browserName = 'Other';
    }
  }
  return browserName;
};

export const isACPEligibile = () => {
  const { cBandPlans } = store.getState();

  return (
    window.vzFlags?.acpIntegrated &&
    cBandPlans.plans?.output?.acpInfo?.nladSubscriberId &&
    cBandPlans.plans?.output?.acpInfo?.nladSubscriberId !== 'null'
  );
};
export const isVFEligibile = () => {
  const { cBandPlans } = store.getState();
  return window.vzFlags?.vfIntegrated && cBandPlans.plans?.output?.acpInfo?.benefit && cBandPlans.plans?.output?.acpInfo?.benefit === 'VFWD';
};
export const isACPCustomTagging = () => {
  const isACPFlow = getQueryParamByName('acp') === 'y';
  const { acpTagging } = window.vzFlags || {};
  return acpTagging && isACPFlow;
};
export const isWHWISPUFlag = () => {
  const { isWHWISPU } = window.vzFlags || {};
  if (isWHWISPU || getSession(isWHWISPU) === 'Y') {
    return true;
  }
};

export const getPrefetch = (preFetchAEM = false) => {
  let isPrefetch = false;
  const preFetch = getSession(preFetchConsts.SESSION_KEY);
  const { search } = window.location;
  const params = new URLSearchParams(search);
  if (preFetch !== null && preFetch === 'true') {
    isPrefetch = true;
  } else if (
    (params &&
      params != null &&
      params.has(preFetchConsts.QUERYSTRING_KEY) &&
      params.get(preFetchConsts.QUERYSTRING_KEY).toLocaleLowerCase() === 'y') ||
    preFetchAEM
  ) {
    setSession(preFetchConsts.SESSION_KEY, 'true');
    isPrefetch = true;
  }
  return isPrefetch;
};

export const isDTDFlow = () => {
  const isDtdFlow = getSession('isDTD') || window.location.href.indexOf('dtd') > -1;
  return isDtdFlow;
};

export const pdcAEMCheck = () => {
  const { pdcFlag } = window.vzFlags || {};
  if (pdcFlag === true || getSession('pdcFlag') === 'Y') {
    return true;
  }
  return false;
};

export const isDesktop = () => viewport() === 'desktop';

export const renderElement = (element, targetId, renderIf) => {
  try {
    /**
     * Brand 3.0 CTA Shifting
     * Use Case :
     * To move a tightly coupled CTA outside of the component tree
     * Tested alternates:
     * React Ref was not feasible with limitations of AEM children Type
     * HOC was not feasible with AEM container class as it cannot hold any state
     * Context requires more updates and glitches were observed in Credit Check
     * */
    const domNode = document.getElementById(targetId);
    if (!renderIf && domNode) {
      ReactDOM.unmountComponentAtNode(domNode);
    } else if (domNode && element) {
      ReactDOM.render(element, domNode);
    }
  } catch (error) {
    // TODO logger
  }
};

export const is5G = getFlowType() === '5G';
export const isLTE = getFlowType() === 'LTE';
export const isBulkQualIndicator = () => {
  if (getSession('bulkQualIndicator') === 'Y') {
    return true;
  }
  return false;
};
// common function to address cbandPro flow
export const isCBandProQualifiedSession = () => {
  // const LQResponseData = getSession('LQResponse');
  // const bundleDetails = LQResponseData ? JSON.parse(LQResponseData)?.output?.bundleDetails : '';
  if (getSession('isCBandQual') === 'Y' && getSession('cbandPro') === 'Y') {
    return true;
  }
  return false;
};

export const buildUpdateProcessStepPayload = (IntendType, data = {}) => ({
  cartInfo: {
    clientAppName: 'VZW-DOTCOM',
    accountNumber: '',
    cartCreator: '',
    processingMTN: isJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
    processStep: data?.processStep || 'ShoppingCart',
    processAction: 'Complete',
    intendType: `${IntendType}`,
    bundleInstallType: '',
  },
  data: {},
});

export const enableSelfSetup = () => {
  const { isNBSSelf } = window.vzFlags || {};
  const { cartDetails } = store.getState();
  // debugger;
  if (isNBSSelf === true && cartDetails?.cartDetailsJson?.orderDetailsView?.installType === 'Self SetUp') {
    return true;
  }
  return false;
};

export const enableProfessional = () => {
  const { isNBSProfessional } = window.vzFlags || {};
  const { cartDetails } = store.getState();
  if (isNBSProfessional === true && cartDetails?.cartDetailsJson?.orderDetailsView?.installType === 'Professional SetUp') {
    return true;
  }
  return false;
};

export const logToContentSquare = (type, message) => {
  window._uxa = window._uxa || [];
  window._uxa.push(['trackPageEvent', `TextMessage ${type}: ${message}`]);
  window._uxa.push(['trackError', `${type}: ${message}`]);
};

export const isFuncComp = () => {
  const isPostCartPage =
    window.location.href.indexOf('contactinfo.html') !== -1 ||
    window.location.href.indexOf('shipping.html') !== -1 ||
    window.location.href.indexOf('orderreview.html') !== -1 ||
    window.location.href.indexOf('payment.html') !== -1;

  if (isPostCartPage) {
    const isEnableFuncComp =
      getSession('enableFuncComp') === 'true' ||
      getSession('enableFuncComp') === true ||
      getSession('enableFuncComp') === 'Y' ||
      getSession('enableFuncComp') === 'y';

    if (isEnableFuncComp && getAPPID() === 'AAL' && !isWHW()) {
      if (enableSelfSetup() || getSession('changeToSelf') === 'Y') {
        return true;
      }
    }
  }

  return false;
};

export const isSequentialFlow = () => getSession('isSequentialFlow') === 'Y';

export const isJointTransactionFlow = () => getAPPID() === 'NSE' && getSession('isJointTransaction') === 'true';

export const getSeqFlowType = () => (getSession('SeqType') ? getSession('SeqType') : '');

export const enablePegaProcessSteps = () => {
  const { enablePegaProcessStep } = window.vzFlags || {};
  if (enablePegaProcessStep === true || getSession('enablePegaProcessStep') === 'Y') {
    return true;
  }
  return false;
};

export const isWHW = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  if (getSession('WHW') === 'true' || getSession('WHW') === true || params.has('whwf_redeem')) {
    return true;
  }
  return false;
};

export const scrollToTop = () => {
  if (isMobile() || isMobileResolution()) {
    const elem = document.getElementById('topFocus');
    if (elem) {
      elem.focus();
    }
  } else {
    window.scrollTo(0, 0);
  }
};

export const checkErrorCode = (errorCode) => {
  // const ErrorCodes = ["06", "400","615","701","1000","1008","1023","3000","3002","3504","3606","3607","15501","17104"];
  const ErrorCodes = window.vzFlags?.msgwithLinkErrorCode;
  if (ErrorCodes.includes(errorCode)) {
    return true;
  }
  return false;
};

export const checkFccLabel = () => {
  const { isBroadBandFacts } = window.vzFlags || {};
  if (isBroadBandFacts === true || getSession('isBroadBandFacts') === 'Y' || getSession('isBroadBandFacts') === true) {
    return true;
  }
  return false;
};

export const phoneNumberValidationCheck = () => {
  const nonVzConsent_dark = window.vzFlags?.nonVzConsent_dark;
  if (nonVzConsent_dark === true) {
    return true;
  }
  return false;
};

export const showLocalOffer = () => {
  const { localOfferFlag } = window.vzFlags || {};
  if (localOfferFlag === true || localOfferFlag === 'true' || getSession('localOfferFlag') === 'Y') {
    return true;
  }
  return false;
};

export const showFwaModalFun = () => {
  const { fwaModalFlag } = window.vzFlags || {};
  if (fwaModalFlag === true || fwaModalFlag === 'true' || getSession('fwaModalFlag') === 'Y') {
    return true;
  }
  return false;
};

export const checkRole = () => {
  let roleOwner = false;
  roleOwner = getCookie('role') && (getCookie('role').toLowerCase() === 'mobilesecure' || getCookie('role').toLowerCase() === 'accountmember');
  return roleOwner;
};

const debounceFunc = () => {
  let timer;
  // console.log("VALUE", val);
  // console.log("TIMER", timer );
  // eslint-disable-next-line func-names
  return function(callBackFn, value, timervalue) {
    // console.log("TIMER", timer );
    clearTimeout(timer);
    // console.log("TESTER", value);
    timer = setTimeout(() => {
      console.log('TESTER', value);
      callBackFn();
    }, timervalue);
  };
};
export const debounce = debounceFunc();

export const safeTechScript = (safetechSessionId) =>
  window.vzFlags && window.vzFlags.isProd
    ? `https://ssl.kaptcha.com/collect/sdk?m=300637&s=${safetechSessionId}`
    : `https://tst.kaptcha.com/collect/sdk?m=300637&s=${safetechSessionId}`;

export const checkUnitAvailability = (id, address2, availableAddressUnit, isOnlyTypeAhead) => {
  // debugger;
  if (
    id === 'address2' &&
    isOnlyTypeAhead === 'no' &&
    address2 &&
    availableAddressUnit &&
    Number(availableAddressUnit?.totalHits) > 0 &&
    availableAddressUnit?.data
  ) {
    const address2Value = address2?.replace(/\s+/g, ' ');
    const availableUnit = availableAddressUnit?.data.filter((unit) => unit?.sublocation?.toLowerCase() === address2Value.trim().toLowerCase());
    return availableUnit?.[0]?.sublocation || '';
  }
  return address2;
};

export const checkStandAloneFccPage = () => {
  if (getCookie('category') && getCookie('site')) {
    return true;
  }
  return false;
};

export const fccConstantValues = {
  flowName: {
    Prepaid: 'PREPAID',
    Unlimited: 'UNLIMITED',
    'Connected-Devices': 'CONNECTED_DEVICES',
    '55+': '55+',
  },

  learnPageFlow: 'InternalFlow',
  NationalRetailerFlow: 'NRFlow',
  subCategories: {
    Prepaid: ['Phoneplan', 'Dataplan', 'Smartwatchplan'],
    'Connected-Devices': ['Tablet', 'Laptop', 'Smartwatch', 'Mobilehotspot', 'Security', 'ConnectedCar'],
    Unlimited: [],
    '55+': [],
  },
  cookieValue: {
    Prepaid: 'Prepaid',
    Unlimited: 'Unlimited',
    'Connected-Devices': 'Connected-Devices',
    '55+': '55+',
  },
};

// eslint-disable-next-line arrow-body-style
export const getFCCFlowName = () => {
  return {
    flowName: fccConstantValues?.flowName?.[getCookie('category')] || '',
    subFlowName: getCookie('subCategory') || '',
    site: getCookie('site') || '',
  };
};

export const isHomeInternetBroadBandFlow = () => {
  if (
    (getSession('fcc') === true || getSession('fcc') === 'true' || getCookie('fcc') === true || getCookie('fcc') === 'true') &&
    !checkStandAloneFccPage()
  ) {
    return true;
  }
  return false;
};

export const isCartCIThrottlePass = (throttleListResult) =>
  throttleListResult &&
  (throttleListResult.includes(cradleThrottleValues.CART_CONTACT_INFO_INTG_ENABLED) ||
    throttleListResult.includes(cradleThrottleValues.CART_CONTACT_INFO_INTG_WHITELISTED));

export const cartContactInfoIntg = () => {
  // const { cradleResponse } = store.getState() || {};
  // const throttleResult = cradleResponse?.cradleResponse || '';
  // const throttlePass = isCartCIThrottlePass(throttleResult);
  const enabledInSession = getSession(CART_CONTACT_INFO_INTG) === 'Y';
  return enabledInSession && isLoggedIn();
};

export const enableAutopayPreview = () => {
  // const { cradleResponse } = store.getState() || {};
  // const throttlePass = cradleResponse?.cradleResponse?.includes('|autopay-preview|');
  // ACT145-1672 - Code Clean up : FWA Cradle API Optimizations SOE UI
  const { SessionValues } = store.getState() || {};
  const throttlePass = SessionValues?.signInCradleValue?.includes('|autopay-preview|');

  const autoPayPreview = getSession('autoPayPreview') === 'Y';
  if (autoPayPreview && !isLoggedIn()) {
    return true;
  }
  return throttlePass && !isLoggedIn();
};

export const GetProcessStepPages = (processStep) => {
  if (processStep && processStep !== '') {
    let pageName = '';
    switch (processStep) {
      case 'Accessories':
        pageName = 'addons.html';
        break;
      case 'InstallType':
        pageName = 'setup.html';
        break;
      case 'ShoppingCart':
        pageName = 'cart.html';
        break;
      case 'PromoHub': // In Joint Transaction scenario, We will get Process Step as PromoHub. We need to redirect to Nextgen Express Cart Page.
        pageName = '/nextgen/expresscart.html';
        break;
      default:
        pageName = '';
        break;
    }
    return pageName;
  }
};

export const GetCurrentPageName = () => {
  const name = getUrlName(window.location.href);
  return `${name}.html`;
};

export const saveAllProcessSteps = () => {
  const name = getUrlName(window.location.href);
  const { Redirection } = store.getState();
  let processStepArray = [];
  processStepArray = Redirection?.allProcessStep;
  if (!Redirection?.allProcessStep.includes(`${name}.html`)) {
    processStepArray.push(`${name}.html`);
  }
  return processStepArray;
};

export const states = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

export const getJointTransactionLine = () => {
  const { SessionValues } = store.getState();
  return SessionValues?.jointTransactionLine ?? '';
};

export const isMoversPhase2 = () => {
  let isMoversPhase2Value = false;
  const moversSession = getSession('moversPh2');
  if (moversSession === true || moversSession === 'true') {
    isMoversPhase2Value = true;
  }
  return isMoversPhase2Value;
};

export const populatePlanNameAndCustomerInfo = (str = '', planName, mtn, firstName) => {
  let newStr = str.replace('{planName}', planName);
  newStr = newStr.replace(
    '##MDN##',
    `${firstName}-${mtn?.substring(mtn?.length - 4)} ${mtn?.substring(0, 3)}.${mtn?.substring(3, 6)}.${mtn?.substring(6)}`,
  );
  return newStr;
};
